import cookie from 'js-cookie';

export default function cookieExists(cookieName) {
  return typeof cookie.get(cookieName) !== 'undefined';
}
